"use strict";

import angular from "angular";

import template from "./progress-value-kpi.component.html";
import "./themes/progress-value-kpi.component.scss";
import "./themes/progress-value-kpi-dark.component-dark.scss";

import { FormatUnits } from "../../../presentation/services/FormatUnits/FormatUnits";

class ProgressValueKpiComponent {
    constructor($filter) {
        this.FormatUnits = new FormatUnits($filter);
    }

    $onInit() {
        this._setViewConfig();
    }

    $onChanges(changes) {
        this._setViewConfig();
    }

    /**
     * @private
     * @description Seta toda a view
     */
    _setViewConfig() {
        if (typeof this.value === "string")
            return (this.viewValue = this.value);

        this.viewValue = this.unit
            ? this.FormatUnits.formatValue(this.unit, this.value)
            : this.value;

        this.viewTotal = this.unit
            ? this.FormatUnits.formatValue(this.unit, this.total)
            : this.total;

        const result = (this.value * 100) / this.total || 0;
        const percentage = result === Infinity ? 0 : result;

        const valuePercentage = percentage > 100 ? 100 : percentage;

        this.percentage = {
            formatted: this.FormatUnits.formatValue(
                "percentage",
                valuePercentage,
                2
            ),
            progress: valuePercentage
        };
    }
}

export { ProgressValueKpiComponent };

ProgressValueKpiComponent.$inject = ["$filter"];

const name = "progressValueKpiComponent";
const def = {
    bindings: {
            label: "<",
            value: "<",
            valueComplement: "<",
            totalComplement: "<",
            total: "<",
            unit: "@",
            customStatus: "<"
        },
        controller: ProgressValueKpiComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
